import { render, staticRenderFns } from "./HistoryAttendanceBureau.vue?vue&type=template&id=2c76906e&scoped=true&"
import script from "./HistoryAttendanceBureau.vue?vue&type=script&lang=js&"
export * from "./HistoryAttendanceBureau.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c76906e",
  null
  
)

export default component.exports